import React, { Component } from "react";
import { Form, Grid } from "semantic-ui-react";
import NumberFormat from "react-number-format";
import InlineError from "../../messages/InlineError";
import { ERR_TEXTBOX_NOT_FILLED } from "../../../ErrorMessages";

class SsnControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultData === undefined ? "" : props.defaultData,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      const element = document.getElementById(nextProps.control.FieldId);
      if (element) element.focus();
    }
    this.setState({
      value: nextProps.defaultData === undefined ? "" : nextProps.defaultData,
    });
  }

  render() {
    const { control, isLeftSearch } = this.props;
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`ssn_${control.FieldId}`}>
        <Grid.Column width={isLeftSearch ? 6 : 6}>
          <Form.Field>
            <label
              htmlFor={control.FieldLabel}
              style={{ color }}
              className="padding-5"
            >
              {control.FieldLabel}
            </label>
          </Form.Field>
        </Grid.Column>
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field error={!!control.error}>
            <NumberFormat
              id={control.FieldId}
              format="###-##-####"
              placeholder={control.FieldLabel}
              name={control.FieldName}
              value={this.state.value}
              onValueChange={(values) => {
                if (this.props.notifyChangeToForm !== undefined)
                  this.props.notifyChangeToForm(this, {
                    name: control.FieldName,
                    value: values.formattedValue,
                  });
              }}
            />
            {this.props.errors[control.FieldName] !== undefined &&
              this.props.errors[control.FieldName] !== "" && (
                <InlineError text={ERR_TEXTBOX_NOT_FILLED} />
              )}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default SsnControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/SsnControl.js